import { api } from './api';

const endpoint = '/dash/lic/';

export const apiLic = {

  async licences(){
    const url = `${endpoint}licences`;
    const result = await api.get(url);
    return result.data;
  },

  async dealers(){
    const url = `${endpoint}dealers`;
    const result = await api.get(url);
    console.log(result)
    return result.data.dealers;
  },
}